export { headersInterceptor } from './headers.interceptor';
